import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { Text } from 'atoms';

export default function ConfirmBeforeUpdate({ visible, handleOk, handleCancel }) {
	return (
		<Modal
			title={
				<Text textAlign="center" fontSize="14px" padding="0 15px">
					Update Confirmation
				</Text>
			}
			visible={visible}
			onOk={handleOk}
			onCancel={handleCancel}
			width={300}
		>
			<Text textAlign="center" fontSize="14px">
				On update your previous saved data will be erased.
			</Text>
			<Text textAlign="center" fontSize="14px">
				Are you sure want to continue?
			</Text>
		</Modal>
	);
}

ConfirmBeforeUpdate.propTypes = {
	visible: PropTypes.bool.isRequired,
	handleOk: PropTypes.func.isRequired,
	handleCancel: PropTypes.func.isRequired,
};
